import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import Button from '../Button'
import { useTranslation } from 'react-i18next'
import { getDateFormat2, getTimeFormat1 } from 'srcReact/helpers/datetimeHelper'
import dayjs from 'dayjs'
import { useDispatch } from 'react-redux'
import { workplaceActions } from 'srcReact/WorkplacePage'
import Spinner from '../Spinner'
import Icon from 'srcReact/components/icons/Icon'

function ValidateRequests({ workplaceId, item, loading, success, openLightProfileModal, lastRef }) {
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
    if (!loading && success) {
      setIsOpen(false)
    }
  }, [loading, success])

  // const handleMemberClick = (userId, screen) => {
  //   const lp = new LightProfileProto()
  //   lp.userId = userId
  //   lp.screen = screen
  //   dispatch(lightProfileActions.openLightProfileModal(lp))
  // }

  const handleValidate = () => {
    dispatch(workplaceActions.approveInviteRequest(workplaceId, item.id))
  }
  const handleDecline = () => {
    dispatch(workplaceActions.rejectInviteRequest(workplaceId, item.id))
  }
  return (
    <section className={styles.mainContentWrapper} ref={lastRef} data-postid={item.id}>
      <div
        id='accordion-title'
        className={`${styles.mainContentAccordionTitle} ${isOpen && styles.isOpened}`}
        aria-expanded={isOpen}
        aria-controls='accordion-content'>
        <div className={styles.title}>
          <div className={styles.title}>
            <button
              type='button'
              className={styles.highlighted}
              onClick={() => openLightProfileModal(item.invited_by.id)}>
              {`${item.invited_by.firstname} ${item.invited_by.lastname}`}
            </button>
            <span
              dangerouslySetInnerHTML={{ __html: t('components.invite_list.inviteTitle', { email: item.email }) }}
            />
          </div>
        </div>
        <Button
          text={isOpen ? t('moderationReport.flagPost.cancelReview') : t('moderationReport.flagPost.review')}
          size='large'
          style={isOpen ? 'tertiary' : 'primary'}
          customStyle={styles.btnCustomStyle}
          handleClick={() => setIsOpen(!isOpen)}
        />
      </div>
      <div
        id='accordion-content'
        className={styles.mainContentAccordionContent}
        aria-labelledby=''
        hidden={!isOpen}
        role='content'>
        <Button
          text={t('components.invite_list.contactUser', {
            username: `${item.invited_by.firstname} ${item.invited_by.lastname}`
          })}
          iconPosition='start'
          customStyle={styles.contactCustomStyle}
          icon={<Icon name='write' size='large24' />}
          icon2={<Icon name='arrow-right' size='large24' />}
          handleClick={() => openLightProfileModal(item.invited_by.id, 'messenger')}
        />
        <ul>
          <li>
            <b>{t('components.invite_list.inviteData.inviteFor')}:</b> {item.email}
          </li>
          <li>
            <b>{t('components.invite_list.inviteData.date')}:</b> {dayjs(item.created_at).format(getDateFormat2())}
            {', '} {dayjs(item.create_at).format(getTimeFormat1())}
          </li>
          <li>
            <b> {t('moderationReport.flagPost.yourDecision')}:</b>
            <div className={styles.decisionButton}>
              <Button
                handleClick={handleValidate}
                text={t('global.accept')}
                size='large'
                style='primary'
                customStyle={styles.btnCustomStyle}
              />
              <Button
                handleClick={handleDecline}
                text={t('global.decline')}
                size='large'
                style='tertiary'
                customStyle={styles.btnCustomStyle}
              />
              {loading && <Spinner customCss={styles.loader} />}
            </div>
          </li>
        </ul>
      </div>
    </section>
  )
}

export default ValidateRequests
